<template>
    <ul class="nav header-navbar-rht">
        <li class="nav-item">
            <!-- <router-link class="nav-link header-sign" to="login">로그인 / 회원가입</router-link> -->
        </li>
        <!-- <li class="nav-item">
            <router-link class="nav-link header-login" to="register">회원가입</router-link>
        </li> -->
    </ul>
</template>